<div class="workSpace">
<!-- filtros -->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-quarter">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate}}</b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }}</span>
      </div>
    </div>
  </div>
  @if(tab){
    <div class="espacioTabla centradoVertical">
        <div class="w3-row" style="margin-bottom: 1vh;">
        <div class="w3-right colorBotonDeNuevo" (click)="abrirFormFormulario('nuevo')">
            {{'admin.cuestionarios.nuevo' | translate}}
            <mat-icon class="iconoMen">add_circle_outline</mat-icon>
        </div>
        </div>
        <div class="w3-row w3-scroll" style="height: 60vh;">
        <table mat-table [dataSource]="cuestionarios">

                @for(val of columnas; track val; let i = $index){
                    <ng-container matColumnDef="{{val}}">
                        <th mat-header-cell *matHeaderCellDef [ngClass]="{'alinCenter':i===3}">
                        {{'admin.cuestionarios.titTab'+i | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element; let j = index" [ngClass]="{'alinCenter':i===3}">
                        @if(i !== 3 && i !== 0 && i !== 5){
                            <span>{{element[val]}}</span>
                        }@else if (i === 0){
                            <span>{{j+1}}</span>
                        }@else if (i === 5){
                            <span>
                                <mat-icon class="iconoMen material-icons-outlined" [ngClass]="{'w3-disabled': element['status'] === 'ready'}" (click)="abrirFormSemaforos(element,'edicion')">edit</mat-icon> 
                                <mat-icon class="iconoMen material-icons-outlined" (click)="eliminarCuestionario(element)">delete</mat-icon> 
                            </span>
                        }@else if (i === 3){
                            <span  (click)="abrirFormSemaforos(element, 'edicionSem')">
                                <mat-icon class="iconoMen material-icons-outlined">settings</mat-icon> 
                            </span>
                        }
                        </td>
                    </ng-container>
                }
                
            <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columnas;"></tr>
        </table>
        <!-- <survey [model] = "surveyModel" ></survey> -->
        </div>
    </div>
  }
  @if (cue || sem) {
    <div class="espacioForm centradoVertical">
    <div class="w3-row zonaFormularios">
        @if (cue) {
            <div class="w3-row headers w3-titulo-contenidomenuSC">
                <span class="w3-margin-left-contenido">{{'admin.cuestionarios.infoCuestionario' | translate}}:</span>
            </div>
            <div class="w3-row" [formGroup]="formCuestionario">
                <!--  -->
                <div class="w3-half" style="margin-top: 1vh;">
                    <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs">{{'admin.cuestionarios.nombreC' | translate}} </span></div>
                    </div>
                    <div class="w3-rest">
                    <div class="zonaInput">
                        <input type="text" class="contentInput" formControlName="nombre">
                    </div>
                    </div>
                </div>
                <!--  -->
                <div class="w3-half" style="margin-top: 1vh;">
                    <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.nombreCorto' | translate}} </span></div>
                    </div>
                    <div class="w3-rest">
                    <div class="zonaInput">
                        <input type="text" class="contentInput" formControlName="nombreCorto">
                    </div>
                    </div>
                </div>
                <!--  -->
                <div class="w3-half" style="margin-top: 1vh;">
                    <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.usuario' | translate}} </span></div>
                    </div>
                    <div class="w3-rest">
                    <div class="zonaInput w3-disabled">
                        <input type="text" class="contentInput" formControlName="usuarioCrea">
                    </div>
                    </div>
                </div>
                <!--  -->
                <div class="w3-half" style="margin-top: 1vh;">
                    <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.permitirMultiples' | translate}} </span></div>
                    </div>
                    <div class="w3-rest">
                    <div style="display: flex; align-items: center; padding: 10px;">
                        <input 
                            type="checkbox" 
                            id="allowMultipleResponses"
                            formControlName="allowMultipleResponses"
                            class="checkbox-input"
                            [ngClass]="{'checkbox-checked': formCuestionario.get('allowMultipleResponses')?.value}">
                        <label for="allowMultipleResponses" class="checkbox-label">
                            {{'admin.cuestionarios.permitirMultiplesDesc' | translate}}
                        </label>
                    </div>
                    </div>
                </div>
                </div>
        }    
      <ng-container>
        <div class="w3-row headers w3-titulo-contenidomenuSC">
          <span class="w3-margin-left-contenido">{{'admin.cuestionarios.semaforos' | translate}}</span>
        </div>
        <div class="w3-row" [formGroup]="formCuestionario">
          <!--  -->
          <div class="w3-half" style="margin-top: 1vh;">
            <div class="texto">
              <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.numSemaforos' | translate}} </span></div>
            </div>
            <div class="w3-rest">
              <div class="zonaInput">
                <select class="contentSelect" formControlName="numeroSemaforos" value="default" (change)="numeroSemaforos()">
                  <option value="default"> {{'admin.cuestionarios.selecSemaforo' | translate}} </option>
                  @for (opt of semaforos; track opt.codigo) {
                    <option value="{{opt.codigo}}">{{opt.nombre}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="w3-row">
            <!-- semaforo 1 -->
            <div class="w3-row" [ngClass]="{'w3-hide': numColors(1)}" style="margin-top: 1vh;">
              <div class="texto">
                <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.semaforo1' | translate}} </span></div>
                <input type="hidden" id="sem1Val1id" name="sem1Val1id" formControlName="sem1Val1id" />
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber w3-disabled"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem1Val1">
                </div>
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem1Val2" (keyup)="ajusteSemaforos(1)">
                    @if(montoCorrectoValidacion(1)){
                      <mat-error class="error-message">
                        {{'admin.cuestionarios.valor' | translate}} <strong> {{'admin.cuestionarios.minimo' | translate}} </strong>
                      </mat-error>
                    }
                </div>
              </div>
              <div class="w3-quarter">
                <div class="texto2">
                  <div class="w3-right zonaTexto3"><span class="w3-right textoInputs"> {{'admin.cuestionarios.selecColor' | translate}} </span></div>
                </div>  
                <div class="zonaInput" style="height: 6vh !important;">
                  <input type="color" class="contentInputColor" formControlName="sem1Col" style="padding: 0 !important;">
                </div>
              </div>
            </div>
            <!-- semaforo 2 -->
            <div class="w3-row" [ngClass]="{'w3-hide': numColors(2)}" style="margin-top: 1vh;">
              <div class="texto">
                <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.semaforo2' | translate}} </span></div>
                <input type="hidden" id="sem2Val1id" name="sem2Val1id" formControlName="sem2Val1id" />
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber w3-disabled"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem2Val1">
                </div>
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem2Val2" (keyup)="ajusteSemaforos(2)">
                  @if (montoCorrectoValidacion(2)) {
                    <mat-error class="error-message">
                      {{'admin.cuestionarios.valor' | translate}} <strong> {{'admin.cuestionarios.minimo' | translate}} </strong>
                    </mat-error>
                  }
                </div>
              </div>
              <div class="w3-quarter">
                <div class="texto2">
                  <div class="w3-right zonaTexto3"><span class="w3-right textoInputs"> {{'admin.cuestionarios.selecColor' | translate}} </span></div>
                </div>  
                <div class="zonaInput" style="height: 6vh !important;">
                  <input type="color" class="contentInputColor" formControlName="sem2Col" style="padding: 0 !important;">
                </div>
              </div>
            </div>
            <!-- semaforo 3 -->
            <div class="w3-row" [ngClass]="{'w3-hide': numColors(3)}" style="margin-top: 1vh;">
              <div class="texto">
                <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.semaforo3' | translate}} </span></div>
                <input type="hidden" id="sem3Val1id" name="sem3Val1id" formControlName="sem3Val1id" />
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber w3-disabled"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem3Val1">
                </div>
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem3Val2" (keyup)="ajusteSemaforos(3)">
                  @if (montoCorrectoValidacion(3)) {
                    <mat-error class="error-message">
                      {{'admin.cuestionarios.valor' | translate}} <strong> {{'admin.cuestionarios.minimo' | translate}} </strong>
                    </mat-error>
                  }
                </div>
              </div>
              <div class="w3-quarter">
                <div class="texto2">
                  <div class="w3-right zonaTexto3"><span class="w3-right textoInputs"> {{'admin.cuestionarios.selecColor' | translate}} </span></div>
                </div>  
                <div class="zonaInput" style="height: 6vh !important;">
                  <input type="color" class="contentInputColor" formControlName="sem3Col" style="padding: 0 !important;">
                </div>
              </div>
            </div>
            <!-- semaforo 4 -->
            <div class="w3-row" [ngClass]="{'w3-hide': numColors(4)}" style="margin-top: 1vh;">
              <div class="texto">
                <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.semaforo4' | translate}} </span></div>
                <input type="hidden" id="sem4Val1id" name="sem4Val1id" formControlName="sem4Val1id" />
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber w3-disabled"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem4Val1">
                </div>
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem4Val2" (keyup)="ajusteSemaforos(4)">
                  @if (montoCorrectoValidacion(4)) {
                    <mat-error class="error-message">
                      {{'admin.cuestionarios.valor' | translate}} <strong> {{'admin.cuestionarios.minimo' | translate}} </strong>
                    </mat-error>
                  }
                </div>
              </div>
              <div class="w3-quarter">
                <div class="texto2">
                  <div class="w3-right zonaTexto3"><span class="w3-right textoInputs"> {{'admin.cuestionarios.selecColor' | translate}} </span></div>
                </div>  
                <div class="zonaInput" style="height: 6vh !important;">
                  <input type="color" class="contentInputColor" formControlName="sem4Col" style="padding: 0 !important;">
                </div>
              </div>
            </div>
            <!-- semaforo 5 -->
            <div class="w3-row" [ngClass]="{'w3-hide': numColors(5)}" style="margin-top: 1vh;">
              <div class="texto">
                <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.cuestionarios.semaforo5' | translate}} </span></div>
                <input type="hidden" id="sem5Val1id" name="sem5Val1id" formControlName="sem5Val1id" />
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber w3-disabled"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem5Val1">
                </div>
              </div>
              <div class="w3-quarter">
                <div class="zonaInput" style="height: 6vh !important;">
                  <input currencyMask class="contentInputNumber"
                    [options]="{ prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix,
                    align: aling}" formControlName="sem5Val2">
                  @if (montoCorrectoValidacion(5)) {
                    <mat-error class="error-message">
                      {{'admin.cuestionarios.valor' | translate}} <strong> {{'admin.cuestionarios.minimo' | translate}} </strong>
                    </mat-error>
                  }
                </div>
              </div>
              <div class="w3-quarter">
                <div class="texto2">
                  <div class="w3-right zonaTexto3"><span class="w3-right textoInputs"> {{'admin.cuestionarios.selecColor' | translate}} </span></div>
                </div>  
                <div class="zonaInput" style="height: 6vh !important;">
                  <input type="color" class="contentInputColor" formControlName="sem5Col" style="padding: 0 !important;">
                </div>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </ng-container>
      <div class="w3-row">
        <div class="botonesModales" (click)="closeFoms()">
          <button mat-stroked-button color="success2" style="height: 3vh; width: 100%;">{{'admin.cuestionarios.cancelar' | translate}}</button>
        </div>
        <div class="botonesModales" [ngClass]="puedeGuardar()">
          <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="guardarDato()">{{'admin.cuestionarios.guardar' | translate}}</button>
        </div>
      </div>
    </div>
    </div>
  }

</div>
